import { protocolAxes, radarAxes } from '../data/protocolData'
// This is the same scoring data from archetypeEngine.ts
const dimensionScores = {
  // Identity options
  'identity-kosher': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
  'identity-halal': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
  'identity-ahimsa': [-1, 0, 0, 1, 1, 0, -1, -1, 0, 0, 1, 1],
  'identity-diabetic': [0, 1, 1, 1, 1, 1, 1, 0, 1, 0, 0, -1],
  'identity-celiac': [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, -1],
  'identity-fodmap': [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, -1],
  'identity-renal': [-1, 0, 1, 0, 0, -1, -1, -1, 0, -1, 0, -1],
  'identity-antihistamine': [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, -1],
  'identity-autoimmune': [0, 1, 1, 1, 1, 0, 1, 0, 0, -1, 0, -1],
  'identity-sattvic': [0, 0, 0, 0, 1, 0, 0, -1, 1, 1, 1, 1],
  'identity-standard': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Default for None
  'identity-none': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Default for None
  // Meal Frequency options
  'mealFrequency-grazer': [1, -1, 0, 0, -1, 1, -1, -1, -1, 0, 0, -1],
  'mealFrequency-daystride': [0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1],
  'mealFrequency-sunfast': [0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 0],
  'mealFrequency-nightbound': [-1, 1, 1, 0, -1, 1, 1, -1, 0, -1, 0, 0],
  // Food Type options
  'foodType-beast': [0, 1, -1, 0, -1, 1, 1, 1, 0, 0, -1, 0],
  'foodType-tide': [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0],
  'foodType-plant': [0, 0, 1, 1, 0, 0, 0, -1, 0, 0, 1, 1],
  'foodType-fusion': [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1],
  // Macronutrient Strategy options
  'macroStrategy-burn': [1, 1, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0],
  'macroStrategy-surge': [1, -1, 0, 0, 0, 0, -1, -1, 0, 0, 0, 0],
  'macroStrategy-flux': [1, 0, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1],
  'macroStrategy-whisper': [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0],
  // Feeding Cycle options
  'feedingCycle-180': [1, 0, -1, 0, 0, 1, 0, 0, 0, 0, 0, 0],
  'feedingCycle-3.4': [1, 1, 0, 0, 0, 1, 0, 0, 0, -1, 0, -1],
  'feedingCycle-6.1': [1, 1, 0, 0, 0, 1, 0, 0, 0, -1, 0, 0],
  'feedingCycle-2.5': [0, 1, 0, 0, 0, 1, 1, 1, 1, -1, 0, -1],
  'feedingCycle-52': [0, 1, 1, 1, 1, 1, 1, -1, 1, 0, 0, 0],
  'feedingCycle-7.0': [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1],
  'feedingCycle-none': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  // Micronutrient Strategy options
  'microStrategy-spice': [0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1],
  'microStrategy-brew': [0, 1, 1, 0, 1, 0, 0, 0, 1, 1, 1, 1],
  'microStrategy-culture': [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  'microStrategy-marrow': [1, 1, 0, 0, 0, 1, 1, 1, 0, 0, -1, -1],
  'microStrategy-elixir': [1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, -1],
  'microStrategy-alloy': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  'microStrategy-super': [1, 0, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0],
  // Exercise Timing options
  'exerciseTiming-emp': [-1, 1, 1, 0, 0, 1, 1, -1, 1, 0, 0, 0],
  'exerciseTiming-prm': [1, 0, 0, 0, 0, 1, 0, 0, 1, 1, 0, 0],
  'exerciseTiming-fed': [1, -1, 0, 0, -1, 1, -1, -1, 0, 0, 0, 0],
  'exerciseTiming-pst': [1, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 1],
  'exerciseTiming-ref': [0, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
  'exerciseTiming-bke': [1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0],
  'exerciseTiming-win': [1, 1, 0, 0, 0, 1, 1, 0, 1, 0, 0, -1],
  'exerciseTiming-none': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
}
// Map the radar axis IDs to their index in the score arrays
const radarAxisIndices = radarAxes.reduce((acc, axis, index) => {
  acc[axis.id] = index
  return acc
}, {})
// The main categories we want to use for building the top combinations
const mainCategories = [
  'identity',
  'mealFrequency',
  'foodType',
  'macroStrategy',
]
const secondaryCategories = ['microStrategy', 'feedingCycle', 'exerciseTiming']
// Function to find compatible combinations for selected outcomes
export function findCompatibleCombinations(selectedOutcomes) {
  // Get the indices of the selected outcomes in the score arrays
  const selectedIndices = selectedOutcomes.map((id) => radarAxisIndices[id])
  // For each axis, find the options that score well for the selected outcomes
  const scoredOptionsByAxis = {}
  protocolAxes.forEach((axis) => {
    scoredOptionsByAxis[axis.id] = axis.options
      .map((option) => {
        const scoreKey = `${axis.id}-${option.value}`
        const score = calculateOptionScore(scoreKey, selectedIndices)
        return { ...option, value: option.value, score }
      })
      .filter((option) => option.score >= 0)
      .sort((a, b) => b.score - a.score)
  })
  // Generate the top 3 combinations using the ranked options from main categories
  const topCombinations = []
  // Create 3 combinations (or fewer if we don't have enough options)
  for (let i = 0; i < 3; i++) {
    const combination = {}
    // Add main categories (identity, mealFrequency, foodType, macroStrategy)
    let validCombination = true
    for (const category of mainCategories) {
      if (scoredOptionsByAxis[category].length > i) {
        combination[category] = scoredOptionsByAxis[category][i].value
      } else if (scoredOptionsByAxis[category].length > 0) {
        // If we don't have enough options, use the last available one
        combination[category] =
          scoredOptionsByAxis[category][
            scoredOptionsByAxis[category].length - 1
          ].value
      } else {
        // If no options available for this category, mark as invalid
        validCombination = false
        break
      }
    }
    if (!validCombination) continue
    // Add secondary categories (microStrategy, feedingCycle, exerciseTiming)
    // Always use the top recommended option for these
    for (const category of secondaryCategories) {
      if (scoredOptionsByAxis[category].length > 0) {
        combination[category] = scoredOptionsByAxis[category][0].value
      } else {
        // If no options, use a default
        const defaultOption = protocolAxes
          .find((axis) => axis.id === category)
          ?.options.find((opt) => opt.value === 'none' || opt.label === 'None')
        if (defaultOption) {
          combination[category] = defaultOption.value
        }
      }
    }
    // Calculate the score and add radar data
    const score = calculateCombinationScore(combination, selectedIndices)
    const radarData = generateRadarData(combination)
    topCombinations.push({
      ...combination,
      _score: score,
      radarData: radarData,
    })
  }
  // Calculate total possible combinations for display purposes
  const allCompatibleCombinations =
    generateAllCompatibleCombinations(scoredOptionsByAxis)
  return topCombinations.length > 0
    ? topCombinations
    : allCompatibleCombinations.slice(0, 3)
}
// Helper function to generate all compatible combinations (used as fallback)
function generateAllCompatibleCombinations(scoredOptionsByAxis) {
  const combinations = []
  // Generate combinations using only the good options (limited to top 4 per category for efficiency)
  const limitedOptionsByAxis = {}
  protocolAxes.forEach((axis) => {
    limitedOptionsByAxis[axis.id] = scoredOptionsByAxis[axis.id].slice(0, 4)
    if (limitedOptionsByAxis[axis.id].length === 0) {
      // If no good options, include the default option
      const defaultOption =
        axis.options.find(
          (o) =>
            o.value === 'none' || o.value === 'standard' || o.label === 'None',
        ) || axis.options[0]
      limitedOptionsByAxis[axis.id] = [
        { ...defaultOption, score: 0, value: defaultOption.value },
      ]
    }
  })
  // Generate all combinations recursively
  function generateCombinations(combination, axisIndex, selectedIndices) {
    if (axisIndex >= protocolAxes.length) {
      const score = calculateCombinationScore(combination, selectedIndices)
      const radarData = generateRadarData(combination)
      combinations.push({
        ...combination,
        _score: score,
        radarData: radarData,
      })
      return
    }
    const axis = protocolAxes[axisIndex]
    for (const option of limitedOptionsByAxis[axis.id]) {
      const newCombination = { ...combination }
      newCombination[axis.id] = option.value
      generateCombinations(newCombination, axisIndex + 1, selectedIndices)
    }
  }
  // We need selectedIndices for score calculation
  const selectedIndices = [0, 1, 2] // Dummy indices, will be replaced in actual function call
  generateCombinations({}, 0, selectedIndices)
  // Sort by score
  combinations.sort((a, b) => b._score - a._score)
  return combinations
}
// Calculate the score for a specific option for the selected outcomes
function calculateOptionScore(scoreKey, selectedIndices) {
  if (!dimensionScores[scoreKey]) return 0
  let totalScore = 0
  selectedIndices.forEach((index) => {
    totalScore += dimensionScores[scoreKey][index]
  })
  return totalScore
}
// Calculate the score for a complete combination for the selected outcomes
function calculateCombinationScore(combination, selectedIndices) {
  // Start with a base score for each selected outcome
  const baseScores = selectedIndices.map(() => 2) // Start at 2 out of 5
  // Add the contribution from each selection
  Object.entries(combination).forEach(([key, value]) => {
    const scoreKey = `${key}-${value}`
    if (dimensionScores[scoreKey]) {
      selectedIndices.forEach((index, i) => {
        baseScores[i] += dimensionScores[scoreKey][index]
      })
    }
  })
  // Ensure scores are between 0 and 5
  const clampedScores = baseScores.map((score) =>
    Math.max(0, Math.min(5, score)),
  )
  // Average the scores
  const totalScore =
    clampedScores.reduce((sum, score) => sum + score, 0) / clampedScores.length
  return totalScore
}
// Generate radar data for a combination
export function generateRadarData(combination) {
  return radarAxes.map((axis, index) => {
    // Start with a base score of 0 (instead of 2)
    let score = 0
    // Add the contribution from each selection
    Object.entries(combination).forEach(([key, value]) => {
      const scoreKey = `${key}-${value}`
      if (
        dimensionScores[scoreKey] &&
        dimensionScores[scoreKey][index] !== undefined
      ) {
        // Add the score from the table
        score += dimensionScores[scoreKey][index]
      }
    })
    // Ensure the score doesn't go below 0
    score = Math.max(0, score)
    // Cap the maximum score at 5 to maintain the radar chart scale
    score = Math.min(5, score)
    return {
      axis: axis.label,
      value: score,
    }
  })
}
// Generate a protocol name for a combination
export function generateProtocolName(combination) {
  // Get the selected options with their labels
  const selectedOptions = {}
  protocolAxes.forEach((axis) => {
    const selectedValue = combination[axis.id]
    const selectedOption = axis.options.find(
      (opt) => opt.value === selectedValue,
    )
    if (selectedOption) {
      selectedOptions[axis.id] = selectedOption.label
    }
  })
  // Generate protocol name based on selections
  const identity = selectedOptions.identity || ''
  const mealFrequency = selectedOptions.mealFrequency || ''
  const foodType = selectedOptions.foodType || ''
  const macroStrategy = selectedOptions.macroStrategy || ''
  // First part of the protocol name (before the pipe)
  let namePart1 = ''
  if (
    identity &&
    identity !== 'None' &&
    mealFrequency &&
    foodType &&
    macroStrategy
  ) {
    namePart1 = `${identity} ${mealFrequency} ${foodType}${macroStrategy}`
  } else if (mealFrequency && foodType && macroStrategy) {
    namePart1 = `${mealFrequency} ${foodType}${macroStrategy}`
  } else if (identity && identity !== 'None' && foodType && macroStrategy) {
    namePart1 = `${identity} ${foodType}${macroStrategy}`
  } else {
    namePart1 = 'Custom Protocol'
  }
  // Second part of the protocol name (after the pipe)
  const feedingCycle = selectedOptions.feedingCycle || ''
  const microStrategy = selectedOptions.microStrategy || ''
  const exerciseTiming = selectedOptions.exerciseTiming || ''
  let namePart2 = ''
  if (
    feedingCycle &&
    microStrategy &&
    exerciseTiming &&
    exerciseTiming !== 'None'
  ) {
    namePart2 = `${feedingCycle} ${microStrategy}-${exerciseTiming}`
  } else if (feedingCycle && exerciseTiming && exerciseTiming !== 'None') {
    namePart2 = `${feedingCycle} ${exerciseTiming}`
  } else if (microStrategy && exerciseTiming && exerciseTiming !== 'None') {
    namePart2 = `${microStrategy}-${exerciseTiming}`
  } else if (feedingCycle && microStrategy) {
    namePart2 = `${feedingCycle} ${microStrategy}`
  } else if (feedingCycle) {
    namePart2 = feedingCycle
  } else if (microStrategy) {
    namePart2 = microStrategy
  } else {
    namePart2 = 'Standard'
  }
  // Complete protocol name
  return `${namePart1} | ${namePart2}`
}
